export const EstadosControlCafeteriaEnum = {
    Pendiente: 1,
    EnProceso: 2,
    Completado: 3,
    Aplazado: 4
}